import React from "react";
import DetailReview from "../../components/Pages/Reviews/Details/Details";

const ReviewDetails = () => {
  return (
    <div>
      <DetailReview />
    </div>
  );
};

export default ReviewDetails;
